import { Editor, Extension, Range } from "@tiptap/core";
import Suggestion, { SuggestionProps, SuggestionOptions } from "@tiptap/suggestion";
import { VariableTag } from "./liquid-suggestion-menu";
import renderLiquidOptions from "./render-liquid-commands";

const LiquidCommands = Extension.create<{
  suggestion: {
    render?: typeof renderLiquidOptions;
    items: (arg: Parameters<Exclude<SuggestionOptions["items"], undefined>>[0]) => VariableTag[]; // Replace with your actual item type
    command?: (p: { editor: Editor; range: Range; props: SuggestionProps }) => void;
  };
}>({
  name: "liquidCommands",
  addOptions() {
    return {
      suggestion: {
        render: renderLiquidOptions,
        items() {
          return [];
        },
        char: "{{",
        startOfLine: false,
        command: ({ editor, range, props }) => {
          props.command({ editor, range, props });
        },
      },
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});

export default LiquidCommands;
